import { strategistsApis } from '@shared/apis';
import { genericQuery } from './generics';

export const useGetStrategistsHandover = genericQuery<strategistsApis.GetStrategistsHandover>(
  strategistsApis.getStrategistsHandover
);
